/**
 * Phone Number Formatter
 * Formats Turkish phone numbers as: +90 (5xx) xxx xxxx
 */

const phoneFormat = {
  init() {
    const phoneInputs = document.querySelectorAll('input[type="tel"]');
    
    phoneInputs.forEach(input => {
      // Bu input görünen (display) input
      const displayInput = input;

      // Base name'i belirle (ör: phone_display -> phone)
      let baseName = displayInput.name || '';
      const isAlreadyDisplay =
        displayInput.getAttribute('data-phone-display') === 'true' ||
        (baseName && baseName.endsWith('_display'));

      if (isAlreadyDisplay && baseName.endsWith('_display')) {
        baseName = baseName.slice(0, -8); // '_display'
      }

      // İlgili gizli input'u bul (ör: name="phone")
      let hiddenInput = null;
      if (baseName) {
        hiddenInput = displayInput.parentNode.querySelector(
          'input[type="hidden"][name="' + baseName + '"]'
        );
      }

      // Eğer gizli input yoksa oluştur
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = baseName || displayInput.name || displayInput.id || 'phone';
        displayInput.parentNode.insertBefore(hiddenInput, displayInput.nextSibling);
      }

      // Eğer zaten _display ise tekrar ekleme, değilse ekle
      if (!isAlreadyDisplay) {
        const newBaseName = baseName || displayInput.name || displayInput.id || 'phone';
        displayInput.name = newBaseName + '_display';
        displayInput.setAttribute('data-phone-display', 'true');
      }

      // Backend'den gelen değerleri işle
      this.syncFromExistingValues(displayInput, hiddenInput);
      
      displayInput.addEventListener('input', (e) => {
        this.formatPhoneNumber(e.target, hiddenInput);
      });
      
      displayInput.addEventListener('keydown', (e) => {
        this.handleKeydown(e, hiddenInput);
      });
      
      displayInput.addEventListener('focus', (e) => {
        if (!e.target.value || e.target.value === '') {
          e.target.value = '+90 ';
        }
        // Cursor'ı +90'dan sonraya getir
        setTimeout(() => {
          e.target.setSelectionRange(4, 4);
        }, 0);
      });

      // Backend değeri sonradan set edebiliyorsa (AJAX vb.), kısa gecikmeli tekrar senkronla.
      const delayedSync = () => {
        if (document.activeElement === displayInput) return;
        this.syncFromExistingValues(displayInput, hiddenInput);
      };
      setTimeout(delayedSync, 0);
      setTimeout(delayedSync, 50);
      setTimeout(delayedSync, 250);
      setTimeout(delayedSync, 1000);
    });
  },

  syncFromExistingValues(displayInput, hiddenInput) {
    const currentDisplayValue = (displayInput.value || '').trim();
    const currentHiddenValue = (hiddenInput.value || '').trim();

    // Eğer görünen input doluysa onu baz al
    if (currentDisplayValue !== '' && currentDisplayValue !== '+90') {
      let numbers = '';

      if (currentDisplayValue.startsWith('+90')) {
        // +90 sonrası rakamları çıkar
        numbers = currentDisplayValue.replace(/^\+90\s*/, '').replace(/\D/g, '');
      } else {
        numbers = currentDisplayValue.replace(/\D/g, '');
      }

      if (numbers.length > 0) {
        hiddenInput.value = numbers;
        displayInput.value = '+90 ' + numbers;
        this.formatPhoneNumber(displayInput, hiddenInput);
        return;
      }

      displayInput.value = '+90 ';
      hiddenInput.value = '';
      return;
    }

    // Görünen boşsa ama gizli doluysa onu göster
    if (currentHiddenValue !== '') {
      const numbers = currentHiddenValue.replace(/\D/g, '');
      if (numbers.length > 0) {
        hiddenInput.value = numbers;
        displayInput.value = '+90 ' + numbers;
        this.formatPhoneNumber(displayInput, hiddenInput);
        return;
      }
    }

    // Hiç veri yoksa başlangıç değeri
    if (!displayInput.value || displayInput.value.trim() === '') {
      displayInput.value = '+90 ';
    }
    if (!hiddenInput.value) {
      hiddenInput.value = '';
    }
  },
  
  formatPhoneNumber(input, hiddenInput) {
    let value = input.value;
    
    // +90 kısmını koruyalım
    if (!value.startsWith('+90 ')) {
      input.value = '+90 ';
      hiddenInput.value = '';
      return;
    }
    
    // Sadece rakamları al (+90'dan sonraki kısım)
    let numbers = value.slice(4).replace(/\D/g, '');
    
    // Maksimum 10 rakam
    if (numbers.length > 10) {
      numbers = numbers.slice(0, 10);
    }
    
    // Gizli input'a sadece rakamları yaz (backend için)
    hiddenInput.value = numbers;
    
    // Formatlama
    let formatted = '+90 ';
    
    if (numbers.length > 0) {
      // İlk 3 rakam parantez içinde
      formatted += '(' + numbers.substring(0, 3);
      
      if (numbers.length > 3) {
        formatted += ') ' + numbers.substring(3, 6);
        
        if (numbers.length > 6) {
          formatted += ' ' + numbers.substring(6, 10);
        }
      } else if (numbers.length === 3) {
        formatted += ')';
      }
    }
    
    input.value = formatted;
  },
  
  handleKeydown(e, hiddenInput) {
    const input = e.target;
    const cursorPosition = input.selectionStart;
    const selectionEnd = input.selectionEnd;
    const value = input.value;
    const hasSelection = cursorPosition !== selectionEnd;
    
    // Ctrl+A veya tüm metin seçili ise
    if (hasSelection) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        e.preventDefault();
        input.value = '+90 ';
        hiddenInput.value = '';
        setTimeout(() => {
          input.setSelectionRange(4, 4);
        }, 0);
        return;
      }
    }
    
    // Backspace ile silme
    if (e.key === 'Backspace') {
      // +90 kısmını koruma
      if (cursorPosition <= 4) {
        e.preventDefault();
        input.setSelectionRange(4, 4);
        return;
      }
      
      // Parantez, boşluk gibi özel karakterlerin üzerinden atla
      const charBeforeCursor = value[cursorPosition - 1];
      if (charBeforeCursor === '(' || charBeforeCursor === ')' || charBeforeCursor === ' ') {
        e.preventDefault();
        // Bir önceki rakamı sil
        const numbers = value.slice(4).replace(/\D/g, '');
        const newNumbers = numbers.slice(0, -1);
        hiddenInput.value = newNumbers;
        
        // Yeniden formatla
        this.updateFormattedValue(input, newNumbers);
      }
    }
    
    // Delete ile silme
    if (e.key === 'Delete' && cursorPosition <= 4) {
      e.preventDefault();
      input.setSelectionRange(4, 4);
    }
    
    // Sol ok tuşu ile +90'ın soluna gitmeyi engelle
    if (e.key === 'ArrowLeft' && cursorPosition <= 4) {
      e.preventDefault();
    }
    
    // Home tuşu ile başa gitmeyi engelle
    if (e.key === 'Home') {
      e.preventDefault();
      input.setSelectionRange(4, 4);
    }
  },
  
  updateFormattedValue(input, numbers) {
    let formatted = '+90 ';
    
    if (numbers.length > 0) {
      formatted += '(' + numbers.substring(0, 3);
      
      if (numbers.length > 3) {
        formatted += ') ' + numbers.substring(3, 6);
        
        if (numbers.length > 6) {
          formatted += ' ' + numbers.substring(6, 10);
        }
      } else if (numbers.length === 3) {
        formatted += ')';
      }
    }
    
    input.value = formatted;
    
    // Cursor pozisyonunu ayarla
    const newPosition = formatted.length;
    setTimeout(() => {
      input.setSelectionRange(newPosition, newPosition);
    }, 0);
  }
};

export default phoneFormat;
